import { useState, useEffect } from 'react';
import { settingsManager, AppSettings } from '../utils/settings';

export const useSettings = () => {
  const [settings, setSettings] = useState<AppSettings>(settingsManager.getSettings());

  useEffect(() => {
    const handleSettingsChange = (newSettings: AppSettings) => {
      setSettings(newSettings);
    };

    settingsManager.addListener(handleSettingsChange);
    
    return () => {
      settingsManager.removeListener(handleSettingsChange);
    };
  }, []);

  return {
    settings,
    updateSettings: settingsManager.updateSettings.bind(settingsManager),
    updateSetting: settingsManager.updateSetting.bind(settingsManager),
    getSetting: settingsManager.getSetting.bind(settingsManager),
    resetToDefaults: settingsManager.resetToDefaults.bind(settingsManager),
  };
};

export const useSetting = <K extends keyof AppSettings>(key: K) => {
  const { settings, updateSetting } = useSettings();
  
  return [
    settings[key],
    (value: AppSettings[K]) => updateSetting(key, value)
  ] as const;
}; 